const createFieldClasses = (error, data) => {
    const dataCheck = data === undefined ? " " : data;
    return `field__container ${error ? "field__container--error" : "field__container--valid"} ${
        dataCheck && "field__container--data"
    }`;
};

export default createFieldClasses;
